<script>
    import { Doughnut } from 'vue-chartjs'

    export default {
        extends: Doughnut,
        props: ['labels', 'datasets'],
        computed: {
            'chartdata': function () {
                return {
                    labels: this.labels,
                    datasets: this.datasets
                }
            }
        },
        mounted() {
            this.renderChart(this.chartdata,
                {responsive: true, maintainAspectRatio: false})
        }
    }
</script>